<template>
  <div class="brand-color">
    <h4>品牌颜色</h4>
    <ul class="">
      <li v-if="loginInfo.current_team_role !== 4">
        <div class="logo-uploader" @click.stop="addColor">
          <i class="avatar-uploader-icon icon-Addto iconfont"></i>
          <p>添加新颜色</p>
        </div>

        <div class="select-color" v-show="colorPickerStatus" @click.stop>
          <div id="picker"></div>
          <div class="color-choices">
            <div class="color-opt">
              <el-select
                v-model="input_type"
                placeholder="请选择"
                @change="changeColor"
              >
                <el-option
                  v-for="item in options"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
            <div class="colot-inp">
              <div v-if="input_type === 'RGB'" class="rgb-input">
                <el-input
                  type="number"
                  v-model.number="colorObj.rgb.r"
                  @change="changeRGB"
                  :max="255"
                  :min="0"
                />
                <el-input
                  type="number"
                  v-model="colorObj.rgb.g"
                  @change="changeRGB"
                  :max="255"
                  :min="0"
                />
                <el-input
                  type="number"
                  v-model="colorObj.rgb.b"
                  @change="changeRGB"
                  :max="255"
                  :min="0"
                />
              </div>
              <div class="hex-input" v-else-if="input_type === 'HEX'">
                <span>#</span>
                <el-input
                  type="text"
                  minlength="3"
                  maxlength="6"
                  v-model.trim="colorObj.hex"
                  @click.stop
                  @change="changeColorInput"
                />
              </div>
              <div class="cmyk-input" v-else>
                <el-input
                  @click.stop
                  @change="changeCMYK"
                  v-model.number="colorObj.cmyk.C"
                  type="number"
                  :max="100"
                  :min="0"
                />
                <el-input
                  @click.stop
                  @change="changeCMYK"
                  v-model.number="colorObj.cmyk.M"
                  type="number"
                  :max="100"
                  :min="0"
                />
                <el-input
                  @click.stop
                  @change="changeCMYK"
                  v-model.number="colorObj.cmyk.Y"
                  type="number"
                  :max="100"
                  :min="0"
                />
                <el-input
                  @click.stop
                  @change="changeCMYK"
                  v-model.number="colorObj.cmyk.K"
                  type="number"
                  :max="100"
                  :min="0"
                />
              </div>
            </div>
          </div>
          <div class="color-btn-wrap">
            <!-- class="cancel-btn" -->
            <el-button @click.stop="colorPickerStatus = false">
              取消
            </el-button>
            <!--class="confirm-btn"-->
            <el-button type="primary" @click.stop="colorSubmit">确认</el-button>
          </div>
        </div>
      </li>
      <li
        v-for="(item, index) in BrandInfo.colors"
        :key="item.id"
        :style="{ backgroundColor: item.rgb }"
      >
        <div class="brand-item-more">
          <!---->
          <!---->
          <span v-if="item.input_type === 'cmyk'">{{
            item.cmyk.replace("cmyk(", "").replace(")", "")
          }}</span>
          <span v-else-if="item.input_type === 'hex'">{{ item.hex }}</span>
          <span v-else>{{
            item.rgb.replace("rgb(", "").replace(")", "")
          }}</span>
          <span
            class="iconfont icon-More brand-color-more"
            @click.stop="selectedIndex(index)"
            v-if="loginInfo.current_team_role !== 4"
          ></span>
        </div>
        <div
          class="color-action"
          v-show="checkColorIndex === index && checkedStatus"
        >
          <p
            class="handle-block-p"
            @click.stop="
              removeDialogStatus = true;
              checkedStatus = false;
            "
          >
            删除
          </p>
        </div>
      </li>
    </ul>

    <remove-dialog :title="'是否确认删除该颜色'" @remove="deleteColor" />
    <!--过期弹出框-->
    <expireTeamDialog />
  </div>
</template>

<script>
import { Brand } from "@/config/axios/new_api";
import iro from "@jaames/iro";
import removeDialog from "../../../../components/dialog/removeDialog.vue";
export default {
  components: { removeDialog },
  props: ["BrandInfo"],
  data() {
    return {
      color: "",
      checkColorIndex: null,
      removeDialogStatus: false,
      colorPickerStatus: false,
      checkedStatus: false,
      input_type: "RGB",
      options: ["RGB", "CMYK", "HEX"],
      colorObj: {
        rgb: {},
        rgbString: "",
        hex: "",
        cmyk: {},
      },
    };
  },
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  },
  mounted() {
    this.checkedColor();
    document.addEventListener("click", this.resetChecked, false);
  },
  methods: {
    resetChecked() {
      this.checkColorIndex = null;
      this.colorPickerStatus = false;
    },
    selectedIndex(index) {
      if (this.checkColorIndex === index) {
        this.checkColorIndex = null;
      } else {
        this.checkColorIndex = index;
      }
      this.colorPickerStatus = false;
      this.checkedStatus = true;
    },
    addColor() {
      let res = this.expireHandle();
      if (res) {
        this.colorPickerStatus = !this.colorPickerStatus;
        this.checkColorIndex = false;
      }
    },
    checkedColor() {
      var _this = this;
      this.colorPicker = new iro.ColorPicker("#picker", {
        width: 170,
        color: "#C8A3FF",
        sliderSize: 10,
        handleRadius: 5,
        padding: 0,
      });

      this.$set(this.colorObj, "rgb", this.colorPicker.color.rgb);
      this.$set(
        this.colorObj,
        "hex",
        this.colorPicker.color.hexString.substring(1)
      );
      this.$set(this.colorObj, "rgbString", this.colorPicker.color.rgbString);
      this.$set(
        this.colorObj,
        "cmyk",
        this.rgbToCmyk(this.colorPicker.color.rgb)
      );
      this.colorPicker.on("color:change", (color) => {
        _this.$set(_this.colorObj, "hex", color.hexString.substring(1));
        _this.$set(_this.colorObj, "rgb", color.rgb);
        _this.$set(_this.colorObj, "rgbString", color.rgbString);
        _this.$set(_this.colorObj, "cmyk", this.rgbToCmyk(color.rgb));
      });
    },
    deleteColor() {
      let item = this.BrandInfo.colors[this.checkColorIndex];
      this.removeDialogStatus = false;
      Brand.colorRemove({ color_id: item.id }).then((res) => {
        if (res.status === 1) {
          this.$message.success("删除成功");
          this.$emit("getData");
          this.checkColorIndex = null;
        }
      });
    },
    colorSubmit() {
      const hexReg = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

      let { rgb, cmyk, hex } = this.colorObj;
      if (hexReg.test(`#${hex}`)) {
        let rgbStr = `rgb(${rgb.r},${rgb.g},${rgb.b})`;
        let cmykStr = `cmyk(${cmyk.C},${cmyk.M},${cmyk.Y},${cmyk.K})`;
        let submitData = {
          input_type: this.input_type.toLowerCase(),
          team_id: this.BrandInfo.id,
          hex: "#" + hex,
          rgb: rgbStr,
          cmyk: cmykStr,
        };
        Brand.colorAdd(submitData).then((res) => {
          if (res.status === 1) {
            this.$message.success("新增成功");
            this.$emit("getData");
            this.colorPickerStatus = false;
          }
        });
      } else {
        this.$message.closeAll();
        this.$message.error("请输入符合规范的十六进制颜色值");
      }
    },
    close() {},

    changeCMYK() {
      let cmyk = this.colorObj.cmyk;
      let status = true;
      for (let i in cmyk) {
        if (cmyk[i] === "") {
          status = false;
        }
        if (cmyk[i] > 100) {
          cmyk[i] = 100;
        }

        if (cmyk[i] < 0) {
          cmyk[i] = 0;
        }
      }
      if (status) {
        this.colorObj.rgb = this.cmykToRgb(cmyk);
        let rgb = this.colorObj.rgb;
        let rgbStr = `rgb(${rgb.r},${rgb.g},${rgb.b})`;
        this.colorObj.hex = this.colorRgb2Hex(rgbStr);
      }
    },
    changeColor(val) {
      if (val === "RGB") {
        this.changeRGB();
      } else if (val === "HEX") {
        this.changeHex();
      } else {
        this.changeCMYK();
      }
      this.input_type = val;
    },
    changeRGB() {
      let rgb = this.colorObj.rgb;
      let status = true;
      for (let i in rgb) {
        if (rgb[i] === "") {
          status = false;
        }
        if (rgb[i] > 255) {
          rgb[i] = 255;
        }
        if (rgb[i] < 0) {
          rgb[i] = 0;
        }
      }
      if (status) {
        this.colorObj.cmyk = this.rgbToCmyk(rgb);
        let rgbStr = `rgb(${rgb.r},${rgb.g},${rgb.b})`;
        this.colorObj.hex = this.colorRgb2Hex(rgbStr);
        this.colorPicker.color.hexString = this.colorObj.hex;
      }
    },
    changeHex() {
      let hex = this.colorObj.hex;
      if (!hex) return false;
      let rgbArr = this.colorHex2Rgb("#" + hex);
      let rgb = this.colorObj.rgb;
      rgb.r = rgbArr[0];
      rgb.g = rgbArr[1];
      rgb.b = rgbArr[2];
    },

    rgbToCmyk(rgb) {
      var R, G, B, C, M, Y, K, maxNum, CMYK;
      R = rgb.r / 255;
      G = rgb.g / 255;
      B = rgb.b / 255;
      if (R === 0 && G === 0 && B === 0) {
        CMYK = {
          C: 0,
          M: 0,
          Y: 0,
          K: 100,
        };
      } else {
        maxNum = Math.max(R, G);
        maxNum = Math.max(maxNum, B);

        K = 1 - maxNum;
        C = (1 - R - K) / (1 - K);
        M = (1 - G - K) / (1 - K);
        Y = (1 - B - K) / (1 - K);

        K = Math.round(K * 100);
        C = Math.round(C * 100);
        M = Math.round(M * 100);
        Y = Math.round(Y * 100);

        CMYK = {
          C,
          M,
          Y,
          K,
        };
      }
      return CMYK;
    },
    // cmyk转rgb的方法
    cmykToRgb(CMYK) {
      var C, M, Y, K, r, g, b, rgb;
      C = parseInt(CMYK.C);
      M = parseInt(CMYK.M);
      Y = parseInt(CMYK.Y);
      K = parseInt(CMYK.K);
      r = Math.round((255 * (100 - C) * (100 - K)) / 10000);
      g = Math.round((255 * (100 - M) * (100 - K)) / 10000);
      b = Math.round((255 * (100 - Y) * (100 - K)) / 10000);
      rgb = {
        r,
        g,
        b,
      };
      return rgb;
    },
    // rgb转16进制
    colorRgb2Hex(rgbValue) {
      //十六进制颜色值的正则表达式
      // var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      // that为传进来的rgb的值
      var that = rgbValue;
      // 如果传进来rgb
      if (/^(rgb|RGB)/.test(that)) {
        var aColor = that.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
        var strHex = "";
        for (var i = 0; i < aColor.length; i++) {
          var hex = Number(aColor[i]).toString(16);
          if (hex.length === 1) {
            hex = "0" + hex;
          }
          if (hex === "0") {
            hex += hex;
          }
          strHex += hex;
        }
        if (strHex.length !== 6) {
          strHex = that;
          // 返回的不是正确的16进制
          return;
        }
        return strHex;
      } else {
        return;
      }
    },
    // 16进制转rgb的方法
    colorHex2Rgb(sColor) {
      var reg = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
      sColor = sColor.toLowerCase();
      if (sColor && reg.test(sColor)) {
        // 如果是三个值，拼接成6个值
        if (sColor.length === 4) {
          var sColorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        // #334455
        var sColorChange = [];
        for (let i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        // return "RGB(" + sColorChange.join(",") + ")";
        return sColorChange;
      } else {
        return;
      }
    },
    changeColorInput(value) {
      const hexReg = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
      const testContent = `#${value}`;
      if (hexReg.test(testContent)) {
        this.colorPicker.color.hexString = value;
        this.$set(this.colorObj, "rgb", this.colorPicker.color.rgb);
        this.$set(
          this.colorObj,
          "hex",
          this.colorPicker.color.hexString.substring(1)
        );
        this.$set(this.colorObj, "rgbString", this.colorPicker.color.rgbString);
        this.$set(
          this.colorObj,
          "cmyk",
          this.rgbToCmyk(this.colorPicker.color.rgb)
        );

        //更新各种数据
      } else {
        this.$message.error("请输入符合规范的十六进制颜色值");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.brand-color {
  li {
    border-radius: 6px;
    @include wh(120px, 120px);
    margin-bottom: 15px;
    position: relative;

    &:hover {
      .brand-item-more {
        display: flex;
      }
    }
  }

  .color-action {
    width: 160px;
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(175, 175, 175, 0.44);
    border-radius: 8px;
    text-align: center;
    padding: 0 5px;
    border: none;
    box-sizing: border-box;
    position: absolute;
    top: 122px;
    left: 0px;
    z-index: 99;
    margin-bottom: 10px;

    p {
      line-height: 44px;
      height: 45px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #424244;
      border-bottom: 1px solid #e7e7e7;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        color: $activeColor;
      }
    }
  }

  .brand-item-more {
    height: 26px;
    margin-top: 94px;
    padding: 0 8px;
    // display: flex;
    justify-content: space-between;
    display: none;

    span {
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      line-height: 20px;
    }
  }

  .select-color {
    @include wh(240px, 351px);
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(175, 175, 175, 0.44);
    border-radius: 8px;
    position: absolute;
    z-index: 99;
    left: 120px;
    bottom: 0;

    #picker {
      padding: 35px 35px 0;
    }

    .color-btn-wrap {
      width: 100%;
      display: flex;
      padding: 0 16px;
      box-sizing: border-box;
      justify-content: space-between;

      button {
        width: 100px;
      }
    }

    ::v-deep( .color-choices) {
      @include wh(100%, 71px);
      padding: 16px;
      box-sizing: border-box;
      display: flex;
      position: relative;

      .color-opt {
        @include wh(79px, 40px);
      }

      .rgb-input {
        margin-left: 3px;

        .el-input {
          width: 40px;
          margin-right: 2px;
          padding: 0;

          &:last-child {
            margin-right: 0;
          }

          input::-webkit-inner-spin-button {
            display: none;
          }
        }
      }

      .hex-input {
        margin-left: 10px;

        .el-input {
          width: 90px;
          margin-left: 5px;
        }
      }

      .cmyk-input {
        margin-left: 3px;

        .el-input {
          width: 30px;
          margin-right: 2px;
          padding: 0;

          &:last-child {
            margin-right: 0;
          }
          input::-webkit-inner-spin-button {
            display: none;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.rgb-input,
.cmyk-input {
  .el-input__inner {
    padding: 0 2px;
  }
}
</style>
